<template>
  <section class="error-area">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="error-wrapper">
            <h1 class="error-heading-title">404</h1>
            <h2 class="section-title">{{ msg.title }}</h2>
            <p class="section-paragraph">{{ msg.description }}</p>
            <div class="error-btn">
              <button class="bd-btn" @click="handleGoHome">{{ msg.backToHome }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import enMsg from '~/public/i18n/en.json'
import ukMsg from '~/public/i18n/uk.json'
import ruMsg from '~/public/i18n/ru.json'

defineProps<{ error: NuxtError }>()

const msgMap: Record<string, { title: string; description: string; backToHome: string }> = {
  en: enMsg.error404,
  uk: ukMsg.error404,
  ru: ruMsg.error404,
}

const locale = computed<string>(() => {
  try {
    const nuxtApp = useNuxtApp()
    const l = (nuxtApp.$i18n as any)?.locale?.value
    if (typeof l === 'string' && l in msgMap) return l
  } catch {/* */}
  return 'en'
})

const msg = computed(() => msgMap[locale.value] ?? msgMap.en)

const handleGoHome = () => clearError({ redirect: '/' })
</script>

<style scoped>
.error-area {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1a1c2e;
  background-image: url('./assets/images/error-bg.webp');
  background-size: cover;
  background-position: center;
  padding: 80px 20px;
}

.container {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  margin-top: -200px;
}

.row {
  display: flex;
  justify-content: center;
}

.col {
  width: 100%;
}

.error-wrapper {
  text-align: center;
}

.error-heading-title {
  font-size: 160px;
  font-weight: 700;
  line-height: 1;
  color: #ffff;
  margin: 0 0 10px;
  font-family: var(--font-inter, sans-serif);
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px;
  font-family: var(--font-inter, sans-serif);
  line-height: 1.3;
}

.section-paragraph {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 36px;
  line-height: 1.7;
  font-family: var(--font-inter, sans-serif);
}

.error-btn {
  display: flex;
  justify-content: center;
}

.bd-btn {
  display: inline-block;
  padding: 16px 44px;
  background: var(--color-primary, #00CE9B);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 150ms ease;
  font-family: var(--font-inter, sans-serif);
  letter-spacing: 0.3px;
}

.bd-btn:hover {
  opacity: 0.85;
}

@media (max-width: 768px) {
  .error-heading-title {
    font-size: 100px;
  }

  .section-title {
    font-size: 26px;
  }
}

@media (max-width: 480px) {
  .error-heading-title {
    font-size: 72px;
  }

  .section-title {
    font-size: 22px;
  }
}
</style>
